import {
  RESET_WHATSAPP,
  UPDATE_WHATSAPP_QUEUES,
  SET_CONVERSATION_LIST,
  SET_CONVERSATION_BY_PROTOCOL,
  SET_SEARCH_CONVERSATION_DRAWER,
  REMOVE_CONVERSATION_LIST,
  SET_MEDIA_GALLERY_DIALOG,
  SET_WHATSAPP_ALL_MIDIA,
  SET_FORWARD_MESSAGE_DIALOG,
  SET_FORWARD_MESSAGE_INITIALIZED,
  SET_FORWARD_MESSAGE_SELECTION,
  SET_FORWARD_MESSAGE_PROTOCOL,
  SET_ACTIVE_SESSION_STATUS,
  CLEAR_FORWARD_MODULE,
} from '../../mutation-types';
import { getFieldsScript } from '@/services/script-service';
import whatsappService from '../../../services/whatsapp-service';
import {
  getMessagesFromJob,
  activeSessionStatus,
} from '@/services/whatsapp-messages-service';

const actions = {
  getQueues({ commit }) {
    return whatsappService.getQueuesWhatsApp().then((response) => {
      commit(UPDATE_WHATSAPP_QUEUES, response.data.data);
    });
  },

  getQueuesByOrg({ commit }, org) {
    return whatsappService.getQueuesWhatsAppByOrg(org).then((response) => {
      commit(UPDATE_WHATSAPP_QUEUES, response.data.data);
    });
  },

  async getScriptCampaign({ dispatch }, campaignId) {
    try {
      const response = await whatsappService.getScriptCampaign(campaignId);
      dispatch('jobs/setScriptActiveJob', response.data, { root: true });
    } catch (err) {
      window.console.log(err);
      dispatch(
        'showSnackbar',
        {
          text: 'Ocorreu um erro ao recuperar o script de atendimento',
          type: 'error',
        },
        { root: true },
      );
    }
  },

  async getScriptQueue({ dispatch }, idWhatsAppQueue) {
    try {
      const response = await whatsappService.getScriptQueue(idWhatsAppQueue);
      dispatch('jobs/setScriptActiveJob', response.data, { root: true });
    } catch (err) {
      window.console.error(err);
      dispatch(
        'showSnackbar',
        {
          text: 'Ocorreu um erro ao recuperar o script de atendimento',
          type: 'error',
        },
        { root: true },
      );
    }
  },

  async getFieldsScripts({ dispatch }, params) {
    const { script_id } = params || {};
    if (!script_id) return;
    const fieldsScript = await getFieldsScript(params);
    dispatch('jobs/setFieldsScriptActiveJob', fieldsScript, { root: true });
  },

  async getWhatsappAllMidia({ commit }, params) {
    const response = await whatsappService.getWhatsappAllMidia(params);

    const mediaList = response.data.mediaList.map((item) => {
      return {
        id: item.id,
        type: item.type,
        protocol: item.protocol,
        from: item.from,
        to: item.to,
        media: item.media.replace(/\\+/g, '').replace(/"+/g, ''),
        caption: item.caption,
        agent: item.agent,
        date: item.date,
        senderType: item.senderType,
      };
    });

    commit(SET_WHATSAPP_ALL_MIDIA, mediaList);
  },

  async getConversationList({ commit }, params) {
    if (params.reset === true) {
      commit(SET_CONVERSATION_LIST, 'reset');
    }
    return new Promise((resolve, reject) => {
      if (params.message != '') {
        whatsappService
          .getConversationList(params.request)
          .then((response) => {
            console.log(response);
            if (response.status === 200) {
              setTimeout(() => {
                commit(SET_CONVERSATION_LIST, {
                  data: response.data.messages,
                  totalPages: response.data.totalPages,
                });
                resolve(true);
              }, 1000);
            } else if (response.status === 204) {
              resolve(false);
            } else {
              commit(SET_CONVERSATION_LIST, 'reset');
              resolve(true);
            }
          })
          .catch((error) => {
            commit(SET_CONVERSATION_LIST, 'reset');
            resolve(true);
          });
      } else {
        commit(SET_CONVERSATION_LIST, 'reset');
        resolve(true);
      }
    });
  },

  removeConversationList({ commit }, params) {
    commit(REMOVE_CONVERSATION_LIST, params);
  },

  getMessagesFromJob({ commit }, params) {
    getMessagesFromJob(params).then((response) => {
      commit(SET_CONVERSATION_BY_PROTOCOL, response.data.data);
    });
  },

  reset({ commit }) {
    commit(RESET_WHATSAPP);
  },

  resetWhatsappAllMidia({ commit }) {
    commit(SET_WHATSAPP_ALL_MIDIA, []);
    commit(SET_MEDIA_GALLERY_DIALOG, { imageRef: null, status: false });
  },

  setSearchConversationDrawer({ commit }, value) {
    commit(SET_SEARCH_CONVERSATION_DRAWER, value);
  },
  dialogMediaGallery({ commit }, { imageRef, status }) {
    commit(SET_MEDIA_GALLERY_DIALOG, { imageRef, status });
  },
  dialogForwardMessage({ commit }, status) {
    commit(SET_FORWARD_MESSAGE_DIALOG, status);
  },
  startForwardMessage({ commit }, { status, protocol }) {
    commit(SET_FORWARD_MESSAGE_INITIALIZED, status);
    commit(SET_FORWARD_MESSAGE_PROTOCOL, protocol);
  },
  setMessageToForward({ commit }, { messageId, checked }) {
    commit(SET_FORWARD_MESSAGE_SELECTION, { messageId, checked });
  },
  clearForwardModule({ commit }) {
    commit(CLEAR_FORWARD_MODULE);
  },
  activeSessionStatus({ commit }, protocolList) {
    activeSessionStatus({ protocol: protocolList }).then((response) => {
      commit(SET_ACTIVE_SESSION_STATUS, response.data);
    });
  },
};

export default actions;
